import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ShopifyIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ShopifyIntegrationResponseDataSchema>>

const queryKey = ["shopifyIntegrationConfiguration"]

export const shopifyIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/shopify`)

      return response.data.data
    },
  })
}
